import React, { useEffect, useState } from "react"
import {
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Form,
  Label,
  Input,
  Row,
  Col,
  InputGroup,
  InputGroupText,
  FormGroup,
} from "reactstrap"
import API from "../../api/axios"
import { useFormik } from "formik"
import * as Yup from "yup"
import { FaPlus } from "react-icons/fa"
import { useNavigate } from "react-router-dom"
import { toast } from "react-toastify"

import "./calender.scss"
const BookingModal = ({
  isOpen,
  toggle,
  timeSlot,
  onSuccess,
  doctorId,
  appointment,
  appointments = [],
  events = [],
}) => {
  const isBlockOverlap = (start, end) => {
    const s = new Date(start)
    const e = new Date(end)

    // Count how many background (blocked) events overlap
    const overlappingBlocks = events.filter(evt => {
      if (evt.display !== "background") return false

      const bs = new Date(evt.start)
      const be = new Date(evt.end)

      // check if time range intersects
      return s < be && e > bs
    })

    const startInBlocked = overlappingBlocks.some(block => {
      const bs = new Date(block.start)
      const be = new Date(block.end)
      return s >= bs && s < be
    })

    //  if start is blocked → don't allow
    if (startInBlocked) return true

    // allow if overlap is at most 1
    return overlappingBlocks.length > 1
  }

  const [services, setServices] = useState([])
  const [searchTerm, setSearchTerm] = useState("")
  const [searchResults, setSearchResults] = useState([])
  const [selectedPatient, setSelectedPatient] = useState(null)
  const [doctorName, setDoctorName] = useState("")

  const [duration, setDuration] = useState("")
  const [statusList, setStatus] = useState([])
  const [startOverlapError, setStartOverlapError] = useState("")
  const [endOverlapError, setEndOverlapError] = useState("")

  const navigate = useNavigate()
  const isEdit = !!appointment

  const formatDateTime = dateString => {
    const date = new Date(dateString)
    const yyyy = date.getFullYear()
    const mm = String(date.getMonth() + 1).padStart(2, "0")
    const dd = String(date.getDate()).padStart(2, "0")
    const hh = String(date.getHours()).padStart(2, "0")
    const min = String(date.getMinutes()).padStart(2, "0")
    return `${yyyy}-${mm}-${dd}T${hh}:${min}`
  }

  const fetchedServices = async () => {
    try {
      const res = await API.get(
        `/users/${doctorId}/services`,
      )
      const fetchedServices = res.data.services
      setServices(res.data.services)
      console.log("😁😀😀res fetchservices", res.data.services)

      const { fname, lname } = res.data.doctor
      setDoctorName(`${fname} ${lname}`)

      if (!isEdit && fetchedServices.length === 1) {
        const singleService = fetchedServices[0]
        formik.setFieldValue("service", String(singleService.id))
        if (singleService?.duration?.value) {
          const newDuration = singleService.duration.value
          setDuration(newDuration)

          const startDate = new Date(timeSlot?.start || new Date())
          if (!isNaN(startDate.getTime())) {
            const endDate = new Date(startDate.getTime() + newDuration * 60000)
            formik.setFieldValue("start", formatDateTime(startDate))
            formik.setFieldValue("end", formatDateTime(endDate))
          }
        }

        if (singleService?.price) {
          formik.setFieldValue("fees", singleService.price)
        }
      } else if (!isEdit && fetchedServices.length > 1) {
        const startDate = new Date(timeSlot.start || new Date())
        if (!isNaN(startDate.getTime())) {
          formik.setFieldValue("start", formatDateTime(startDate))
        }
      }
    } catch (error) {
      console.error("Error fetching services", error)
    }
  }

  const fetchstatus = async () => {
    try {
      const token = localStorage.getItem("authToken")
      const res = await API.get(`/statusList`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      setStatus(res.data.status || []) //
      // console.log("status fetched", res.data.status)
      if (!isEdit) {
        const bookedStatus = res.data.status.find(
          status => status.name === "Booked",
        )

        if (bookedStatus) {
          formik.setFieldValue("statusId", bookedStatus.id)
          console.log("Setting default statusId to Booked:", bookedStatus.id)
        } else {
          console.warn("Booked status not found!")
        }
      }
    } catch (error) {
      console.error("Error fetching status", error.message)
    }
  }

  useEffect(() => {
    if (!isEdit && isOpen && statusList.length > 0) {
      const bookedStatus = statusList.find(status => status.name === "Booked")
      if (bookedStatus) {
        formik.setFieldValue("statusId", bookedStatus.id)
      }
      console.log("Setting default statusId to Booked:", bookedStatus?.id)
    }
  }, [isEdit, isOpen, statusList])

  const formik = useFormik({
    initialValues: {
      // patientId: "",
      service: "",
      start: "",
      end: "",
      statusId: "",
      fees: "",
    },
    validationSchema: Yup.object({
      // patientId: isEdit
      //   ? Yup.string()
      //   : Yup.string().required("Please select a patient"),
      service: Yup.string().required("Please select a service"),
      statusId: isEdit
        ? Yup.string().required("Please select a status")
        : Yup.string(),
      fees: Yup.number()
        .typeError("Fees must be a number")
        .required("Fees is required")
        .min(0, "Fees must be at least 0"),
    }),

    onSubmit: async values => {
      // console.log("form submitted this value", values)
      const start = new Date(values.start)
      const end = new Date(values.end)

      if (isBlockOverlap(start, end)) {
        toast.error("Doctor is unavailable at this time.")
        return
      }

      try {
        const authToken = localStorage.getItem("authToken")

        const payload = {
          appointmentStartTime: new Date(values.start),
          appointmentEndTime: new Date(values.end),
          patientId: formik.values.patientId || appointment.patientId,

          doctorId: Number(doctorId),
          serviceId: Number(values.service),
          statusId: Number(values.statusId),
          fees: Number(values.fees),
        }

        if (isEdit) {
          console.log("updating appointment with id", appointment?.id)

          const res = await API.put(
            `/appointments/${appointment.id}`,
            payload,
            {
              headers: {
                Authorization: `Bearer ${authToken}`,
                "Content-Type": "application/json",
              },
            },
          )

          toast.success("Appointment updated!")
        } else {
          const res = await API.post(
            "/appointments",
            payload,
            {
              headers: {
                Authorization: `Bearer ${authToken}`,
                "Content-Type": "application/json",
              },
            },
          )

          toast.success("Booking successful!")
        }

        toggle()
        onSuccess()
      } catch (error) {
        console.error("Error saving appointment", error.message)
        toast.error("Failed to save appointment.")
      }
    },
  })

  useEffect(() => {
    if (isOpen) {
      fetchedServices()

      fetchstatus()
    }
  }, [isOpen])

  useEffect(() => {
    if (
      isOpen &&
      isEdit &&
      appointment &&
      services.length > 0 &&
      statusList.length > 0
    ) {
      console.log(" Received appointment:", appointment)
      console.log(" Current statusList:", statusList)

      const patientId =
        appointment.patientId != null ? String(appointment.patientId) : ""

      // Set all form fields including statusId directly
      const formValues = {
        patientId,
        service: String(appointment.serviceId || ""),
        start: formatDateTime(appointment.appointmentStartTime),
        end: formatDateTime(appointment.appointmentEndTime),
        statusId:
          appointment.statusId != null ? String(appointment.statusId) : "",
        fees: appointment.fees ?? "",
      }

      console.log(" Setting Form Values:", formValues)
      formik.setValues(formValues)

      const selectedService = services.find(
        s => s.id.toString() === String(appointment.serviceId),
      )

      if (selectedService?.duration?.value) {
        setDuration(selectedService.duration.value)
        console.log(" Service Duration:", selectedService.duration.value)
      }

      if (selectedService?.price) {
        formik.setFieldValue("fees", selectedService.price)
      }
      const name = appointment.patientName || ""
      setSearchTerm(name)
      setSelectedPatient({
        id: appointment.patientId || null,
        fname: name.split(" ")[0] || "",
        lname: name.split(" ")[1] || "",
      })
    }
  }, [isOpen, isEdit, services, statusList, appointment])

  //  Reset form if new appointment
  useEffect(() => {
    if (!isEdit && isOpen) {
      formik.resetForm()
      setSearchTerm("")
      setSearchResults([])
      setSelectedPatient(null)
      setDuration("")
    }
  }, [isOpen])

  useEffect(() => {
    console.log("formik errors:", formik.errors)
  }, [formik.errors])

  useEffect(() => {
    console.log("Appointments:", appointments)
  }, [appointments])

  const handleSearchChange = async e => {
    const value = e.target.value
    setSearchTerm(value)

    if (value.trim() === "") {
      setSearchResults([])
      return
    }

    try {
      const authToken = localStorage.getItem("authToken")

      const res = await API.get(
        `/patients/search?search=${value}`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "application/json",
          },
        },
      )
      setSearchResults(res.data.patients || [])
    } catch (error) {
      console.error("Error searching patients", error)
    }
  }

  const handlePatientSelect = patient => {
    setSelectedPatient(patient)
    setSearchTerm(`${patient.fname} ${patient.lname}`)
    setSearchResults([])
    formik.setFieldValue("patientId", String(patient.id))

    formik.setFieldTouched("patientId", true)
  }

  useEffect(() => {
    if (appointment) {
      console.log("Opening BookingModal with appointment:", appointment)
    }
  }, [appointment])

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        {isEdit ? "Edit Appointment" : "Book Appointment"}
      </ModalHeader>
      <ModalBody>
        <Form onSubmit={formik.handleSubmit}>
          <Row>
            <Col md="12" className="position-relative">
              <Label>Patient Name</Label>
              <InputGroup>
                <Input
                  placeholder="Search patient"
                  value={searchTerm}
                  onChange={handleSearchChange}
                  disabled={isEdit}
                  required
                />
                <InputGroupText
                  style={{ cursor: "pointer" }}
                  onClick={() => navigate("/patient")}
                  title="Add new patient"
                >
                  <FaPlus size={25} />
                </InputGroupText>
              </InputGroup>
              <Input
                type="hidden"
                name="patientId"
                value={formik.values.patientId}
              />
              {formik.errors.patientId && formik.touched.patientId && (
                <div className="text-danger">{formik.errors.patientId}</div>
              )}
              {searchResults.length > 0 && (
                <ul className="dropdown-menu show w-100 shadow-lg bg-light rounded">
                  {searchResults.map(user => (
                    <li key={user.id}>
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={() => handlePatientSelect(user)}
                      >
                        {user.fname} {user.lname}
                      </button>
                    </li>
                  ))}
                </ul>
              )}
            </Col>
          </Row>
          <Row className="mt-3">
            <Col>
              <Label for="doctorName">Doctor</Label>
              <Input type="text" id="doctorName" value={doctorName} disabled />
            </Col>
          </Row>
          <Row className="mt-3">
            <Col>
              <Label for="service">Select Service</Label>
              <Input
                type="select"
                name="service"
                id="service"
                onChange={e => {
                  const selectedServiceId = e.target.value
                  formik.setFieldValue("service", selectedServiceId)

                  const selectedService = services.find(
                    s => s.id.toString() === selectedServiceId,
                  )

                  if (selectedService) {
                    if (selectedService?.duration?.value) {
                      const newDuration = selectedService.duration.value
                      setDuration(newDuration)

                      const startDate = new Date(
                        isEdit
                          ? formik.values.start
                          : timeSlot?.start || new Date(),
                      )
                      if (!isNaN(startDate.getTime())) {
                        const endDate = new Date(
                          startDate.getTime() + newDuration * 60000,
                        )
                        formik.setFieldValue("start", formatDateTime(startDate))
                        formik.setFieldValue("end", formatDateTime(endDate))
                      }
                    } else {
                      setDuration("")
                      formik.setFieldValue("start", "")
                      formik.setFieldValue("end", "")
                    }

                    // ✅ Auto-fill fees
                    formik.setFieldValue("fees", selectedService.price || "")
                  }
                }}
                onBlur={formik.handleBlur}
                value={formik.values.service}
              >
                <option value="">-- Select Service --</option>
                {services.map(service => (
                  <option key={service.id} value={service.id}>
                    {service.name} ({service.duration?.value || 0} mins - ₹
                    {service.price})
                  </option>
                ))}
              </Input>

              {formik.errors.service && formik.touched.service && (
                <div className="text-danger">{formik.errors.service}</div>
              )}
            </Col>
          </Row>
          <Row className="mt-3">
            <Col>
              <Label>Duration (minutes)</Label>
              <Input type="text" value={duration} disabled />
            </Col>
          </Row>
          <Row className="mt-3">
            <Col>
              <Label>Fees</Label>
              <Input
                type="number"
                name="fees"
                value={formik.values.fees}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.errors.fees && formik.touched.fees && (
                <div className="text-danger">{formik.errors.fees}</div>
              )}
            </Col>
          </Row>

          <Row className="mt-3">
            <Col md="6">
              <Label>Start Time</Label>
              <Input
                type="datetime-local"
                name="start"
                step={300}
                className="time-input"
                value={formik.values.start}
                onChange={e => {
                  const inputStart = new Date(e.target.value)
                  if (isNaN(inputStart.getTime())) return

                  const newEnd = new Date(
                    inputStart.getTime() + duration * 60000,
                  )

                  if (isBlockOverlap(inputStart, newEnd)) {
                    setStartOverlapError("Doctor is unavailable at this time")
                    formik.setFieldValue("start", "")
                    formik.setFieldValue("end", "")
                    return
                  }

                  // Check appointment overlap
                  const isOverlapping = appointments.some(app => {
                    if (isEdit && app.id === appointment.id) return false
                    const existingStart = new Date(
                      app.extendedProps?.fullData?.appointmentStartTime,
                    )
                    const existingEnd = new Date(
                      app.extendedProps?.fullData?.appointmentEndTime,
                    )
                    return inputStart < existingEnd && newEnd > existingStart
                  })

                  if (isOverlapping) {
                    setStartOverlapError("Appointment is already booked")
                    formik.setFieldValue("start", "")
                    formik.setFieldValue("end", "")
                  } else setStartOverlapError("")
                  formik.setFieldError("start", "")
                  formik.setFieldValue("start", formatDateTime(inputStart))
                  formik.setFieldValue("end", formatDateTime(newEnd))
                }}
              />
              {startOverlapError && (
                <div className="text-danger">{startOverlapError}</div>
              )}
            </Col>
            <Col md="6">
              <Label>End Time</Label>
              <Input
                type="datetime-local"
                name="end"
                className="time-input"
                step={300}
                value={formik.values.end}
                onChange={e => {
                  const inputEnd = new Date(e.target.value)
                  if (isNaN(inputEnd.getTime()) || !duration) return

                  const newStart = new Date(
                    inputEnd.getTime() - duration * 60000,
                  )
                  if (isNaN(newStart.getTime())) return

                  if (isBlockOverlap(newStart, inputEnd)) {
                    setEndOverlapError("Doctor is unavailable at this time")
                    formik.setFieldValue("start", "")
                    formik.setFieldValue("end", "")
                    return
                  }

                  let hasOverlap = false

                  for (let app of appointments) {
                    if (isEdit && app.id === appointment.id) continue

                    const existingStart = new Date(
                      app.extendedProps?.fullData?.appointmentStartTime,
                    )
                    const existingEnd = new Date(
                      app.extendedProps?.fullData?.appointmentEndTime,
                    )

                    // Core logic: overlap if ranges intersect
                    const overlaps =
                      newStart < existingEnd && inputEnd > existingStart

                    if (overlaps) {
                      hasOverlap = true
                      break
                    }
                  }

                  if (hasOverlap) {
                    setEndOverlapError("Appointment is already booked")
                    formik.setFieldValue("start", "")
                    formik.setFieldValue("end", "")
                  } else {
                    setEndOverlapError("")
                    formik.setFieldValue("start", formatDateTime(newStart))
                    formik.setFieldValue("end", formatDateTime(inputEnd))
                  }
                }}
              />

              {endOverlapError && (
                <div className="text-danger">{endOverlapError}</div>
              )}
            </Col>
          </Row>
          <Row className="mt-3">
            {isEdit ? (
              <Col>
                <Label for="status">Select Status</Label>
                <Input
                  type="select"
                  name="statusId"
                  id="statusId"
                  value={formik.values.statusId}
                  onChange={e => {
                    console.log("selected statusId:", e.target.value)

                    formik.handleChange(e)
                  }}
                  onBlur={formik.handleBlur}
                >
                  <option value="">-- Select Status --</option>
                  {statusList.map(status => (
                    <option key={status.id} value={String(status.id)}>
                      {status.name}
                    </option>
                  ))}
                </Input>
                {formik.errors.statusId && formik.touched.statusId && (
                  <div className="text-danger">{formik.errors.statusId}</div>
                )}

                {formik.errors.statusId && formik.touched.statusId && (
                  <div className="text-danger">{formik.errors.statusId}</div>
                )}
              </Col>
            ) : null}
          </Row>
          <div className="text-center">
            <Button color="primary" type="submit" className="mt-4 mb-4">
              {/* <pre>{JSON.stringify(formik.values, null, 2)}</pre> */}

              {isEdit ? "Update Appointment" : "Book Appointment"}
            </Button>
          </div>
        </Form>
      </ModalBody>
    </Modal>
  )
}

export default BookingModal
